import ReferralsContainer from './ReferralsContainer';

export default ReferralsContainer;
